import React, { Component } from "react";

import "../App.css";
import "../css/style.css";
import "../css/bootstrap.css";
import logo from "../Assets/mathisadmission.png";

class Racine extends Component {
  constructor(props) {
    super(props);
    this.state = {
      random: Math.floor(Math.random() * 7 - 5 + 1) + 5,
      answer: "",
      question: 1,
      result: 0,
      message: "C'est parti!",
      messageColor: "black-message",
    };
  }

  mySubmitHandlerOperation = (event) => {
    event.preventDefault();
    var sqrt = Math.sqrt(this.state.random);
    var good = Math.round(sqrt * 10) / 10;
    if (Number(this.state.answer) === good) {
      this.setState({ messageColor: "green-message" });
      this.setState({
        message:
          "Correct : " +
          String.fromCharCode(8730) +
          this.state.random +
          " = " +
          good,
      });
    } else {
      this.setState({ messageColor: "red-message" });
      this.setState({
        message:
          "Erreur : " +
          String.fromCharCode(8730) +
          this.state.random +
          " = " +
          good,
      });
    }
    var rand = Math.floor(Math.random() * 10) + 1;
    while (
      rand !== 2 &&
      rand !== 3 &&
      rand !== 5 &&
      rand !== 6 &&
      rand !== 7 &&
      rand !== 10
    ) {
      rand = Math.floor(Math.random() * 10) + 1;
    }
    var que = Math.floor(Math.random() * 2) + 1;
    var sqr = Math.sqrt(rand);
    var res = Math.round(sqr * 10) / 10;
    this.setState({ random: rand, question: que, result: res, answer: "" });
  };

  mySubmitHandlerResultat = (event) => {
    event.preventDefault();
    var good = this.state.random;
    if (Number(this.state.answer) === good) {
      this.setState({ messageColor: "green-message" });
      this.setState({
        message:
          "Correct : " +
          this.state.result +
          " = " +
          String.fromCharCode(8730) +
          good,
      });
    } else {
      this.setState({ messageColor: "red-message" });
      this.setState({
        message:
          "Erreur : " +
          this.state.result +
          " = " +
          String.fromCharCode(8730) +
          good,
      });
    }
    var rand = Math.floor(Math.random() * 10) + 1;
    while (
      rand !== 2 &&
      rand !== 3 &&
      rand !== 5 &&
      rand !== 6 &&
      rand !== 7 &&
      rand !== 10
    ) {
      rand = Math.floor(Math.random() * 10) + 1;
    }
    var que = Math.floor(Math.random() * 2) + 1;
    var sqr = Math.sqrt(rand);
    var res = Math.round(sqr * 10) / 10;
    this.setState({ random: rand, question: que, result: res, answer: "" });
  };

  myChangeHandler = (event) => {
    this.setState({ answer: event.target.value });
  };

  // componentDidMount() {
  //
  // }

  render() {
    //Si question = 1 alors racine posée
    if (this.state.question === 1) {
      return (
        <div className="App">
          <div className="navigation">
            <img
              className="website-logo"
              src={logo}
              alt="Logo Mathis Admission"
            />
            <h1 className="website-title-text">Prepa Tage Mage</h1>
          </div>

          <div className="row" style={{ marginTop: 40, marginBottom: 40 }}>
            <div className="col">
              <h2 className="menu-principal-text">Racine</h2>
            </div>
          </div>

          <div className="container">
            <p>
              Attention à bien utiliser un point pour les nombres décimaux.
              Exemple : pour 2,4 écrivez 2.4
            </p>
            <p className={this.state.messageColor}>{this.state.message}</p>
            <form
              className="col"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
              onSubmit={this.mySubmitHandlerOperation}
            >
              <div className="row">
                <label className="label-exos">
                  {String.fromCharCode(8730)}
                  {this.state.random} = ?
                </label>
              </div>
              <input
                className="input-square"
                type="float"
                name="answer"
                value={this.state.answer} 
                onChange={this.myChangeHandler}
              />
              <input
                className="validate-button"
                style={{ backgroundColor: "#00cfa4" }}
                type="submit"
                value="Valider"
              />
            </form>
            <p>Besoin d'un peu d'aide ? Scroll la page pour voir le cours ;)</p>

          </div>

          <div className="row" style={{ marginTop: 40, marginBottom: 40 }}>
            <div className="col-12 col-lg-4">
              <a className="all-button" href="/">
                Retour au menu
              </a>
            </div>
          </div>

          <div class="rappel">
            <h3>Rappel de cours :</h3>
            <div>
              <p> √1 =  1</p>
              <p> √2 =  1.4</p>
              <p> √3 =  1.7</p>
              <p> √4 =  2</p>
              <p> √5 =  2.2</p>
              <p> √6 =  2.4</p>
              <p> √7 =  2.6</p>
              <p> √8 =  2.8</p>
              <p> √9 =  3</p>
              <p> √10 =  3.2</p>
            </div>
          </div>

        </div>
      );
    } else {
      return (
        <div className="App">
          <div className="navigation">
            <img
              className="website-logo"
              src={logo}
              alt="Logo Mathis Admission"
            />
            <h1 className="website-title-text">Prepa Tage Mage</h1>
          </div>

          <div className="row" style={{ marginTop: 40, marginBottom: 40 }}>
            <div className="col">
              <h2 className="menu-principal-text">Racine</h2>
            </div>
          </div>

          <div className="container">
            <p>
              Attention à bien utiliser un point pour les nombres décimaux.
              Exemple : pour 2,4 écrivez 2.4
            </p>
            <p className={this.state.messageColor}>{this.state.message}</p>
            <form
              className="col"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
              onSubmit={this.mySubmitHandlerResultat}
            >
              <div className="row">
                <label className="label-exos">
                  {this.state.result} = {String.fromCharCode(8730)}?
                </label>
              </div>
              <input
                className="input-square"
                type="float"
                name="answer"
                value={this.state.answer} 
                onChange={this.myChangeHandler}
              />
              <input
                className="validate-button"
                style={{ backgroundColor: "#00cfa4" }}
                type="submit"
                value="Valider"
              />
            </form>
            <p>Besoin d'un peu d'aide ? Scroll la page pour voir le cours ;)</p>

          </div>

          <div className="row" style={{ marginTop: 40, marginBottom: 40 }}>
            <div className="col-12 col-lg-4">
              <a className="all-button" href="/">
                Retour au menu
              </a>
            </div>
          </div>

          <div class="rappel">
            <h3>Rappel de cours :</h3>
            <div>
              <p> √1 =  1</p>
              <p> √2 =  1.4</p>
              <p> √3 =  1.7</p>
              <p> √4 =  2</p>
              <p> √5 =  2.2</p>
              <p> √6 =  2.4</p>
              <p> √7 =  2.6</p>
              <p> √8 =  2.8</p>
              <p> √9 =  3</p>
              <p> √10 =  3.2</p>
            </div>
          </div>
        </div>
      );
    }
  }
}

export default Racine;
